var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"loading":_vm.batchJobStarting,"icon":"mdi-play","label":_vm.$t('integrations.batchjobs.run_batchjob'),"text":""},on:{"click":_vm.runJob}})}
var staticRenderFns = []

export { render, staticRenderFns }